<template>


    <div
      :class="[
                'form-field-wrapper',
                dataType == 'textarea' ? 'lrg' : '',
                error == true ? 'err' : '',
              ]"
    >
      <textarea
        v-if="dataType == 'textarea'"
        rows="4"
        cols="10"
        class="form-field"
        :placeholder="defaultText"
        :type="dataType"
        v-model="userInput"

      >
      </textarea>

      <template
        v-else-if="dataType == 'select'">
        <!-- <label class="form-field-label">{{defaultText}}</label> -->
        <select
          v-bind:value="userInput"

          class="form-field"
          :type="dataType"
          @change="onSelectInputChanged"
        >
          <!-- <option value="P" selected>PROVINCE</option> -->
          <option disabled value="">{{defaultText}}</option>
          <option
            v-for="(option) in selectOptions"
            :value="option.id"
            :key="option.id"
          >
            {{option.value}}
          </option>
          <!-- <option value="BA">Alberta</option>
          <option value="BC">British Columbia</option>
          <option value="MB">Manitoba</option> -->
        </select>
      </template>

      <input
        v-else
        v-on:input="(e) => { dataFilter(e) }"
        v-bind:value="userInput"

        class="form-field"
        :placeholder="defaultText"
        :type="dataType"
      >


    </div>

</template>

<script>
export default {
    name: 'Input',
    data(){
      return {
        userInput: null,
        error: false
      }
    },
    props: {
      defaultText: String,
      dataType: String,
      customFilter: Function,
      regex: {
        type: String,
        default: null,
      },
      onInputCB: {
        default: null,
      },
      selectOptions: {
        type: Array,
        default: null,
      },
    },

    updated(){

    },

    methods: {
      hasRegex(){
        let regexObj = new RegExp(this.regex);
        let dataValid = regexObj.test(this.userInput);

        console.log('data val: ', this.userInput)
        console.log('regex result: ', this)

        if(!dataValid) {
          this.error = true;
          return false;

        } else {
          this.error = false;
          return true;

        }

      },

      dataFilter(e) {
        let data = e.target.value;
        this.userInput = data;

        console.log('whitespace check')
        if (/\S/.test(data) && data !== ''){

          console.log('not whitespace')

          if(this.regex){
            console.log('regex check')
            this.hasRegex(e);
          }

          if(this.customFilter){
            let cbBool = this.customFilter(this.userInput);
            this.error = cbBool;

          }


        } else {
          this.error = true;

        }


        this.$emit('input', this.userInput);

        if(this.onInputCB != null){
          console.log('nonNull call')
          this.onInputCB(this.error);
        }



      },

      onSelectInputChanged(event) {
        console.log('onSelectInputChanged', event);

        this.userInput = event.target.value;
        this.error = false;

        this.$emit('input', this.userInput);

        this.onInputCB(this.error);

        // if( value )
      },
    }

}
</script>

<style lang="scss">
@import "../../styles/_variables.scss";
@import "../../styles/_mixins.scss";

.form-field-wrapper {
  color: $yellow;
  border: solid 1.75px $yellow;
  width: calc(100% - .5em);
  background: transparent;
  position: relative;
  overflow: hidden;
  margin: 0 auto .5em auto;
  height: 2.45rem;
  border-radius: .25em;

  &.lrg {
    height: 6rem;
  }

  &.err {
    border-color: red;
  }

}

.form-field {
  font-family: inherit;
  font-size: 1rem;
  text-transform: uppercase;
  color: $brown;
  font-weight: inherit;
  background: transparent;
  border: none;

  width: calc(100% - 15px);
  height: 85%;

  position: absolute;
  top: 50%;
  left: 50%;
  @include crossBrowser(transform, translate(-50%, -50%));

  &::placeholder {
    font-family: inherit;
    font-size: inherit;
    text-transform: uppercase;
    color: inherit;

  }

}

.form-field-label {
  font-family: inherit;
  font-size: 1rem;
  text-transform: uppercase;
  color: $brown;
  font-weight: inherit;
  background: transparent;
  border: none;
  text-align: left;

  width: calc(100% - 15px);
  // height: 85%;

  position: absolute;
  top: 50%;
  left: 50%;
  @include crossBrowser(transform, translate(-50%, -50%));

}

</style>
